import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ScriptStore } from 'src/app/store/script.store';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  private scripts: any = {};
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve) => {
      if (!this.isBrowser) {
        resolve({ script: name, loaded: false, status: 'Server-side skip' });
        return;
      }
      // resolve if already loaded (in memory or already present in the DOM)
      const alreadyInDom = !!document.querySelector(`script[src="${this.scripts[name].src}"]`);
      if (this.scripts[name].loaded || alreadyInDom) {
        this.scripts[name].loaded = true;
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
